module.exports = __webpack_public_path__ + "img/gallery-4.81835d65.jpg";